import React, { useState } from "react";
import { useEffect } from "react";
import { Tree, NodeModel, DropOptions } from "@minoru/react-dnd-treeview";
import { useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import { Node } from "./Node";
import { DraggedNode } from "./DraggedNode";
import styles from "./SideBar.module.css";
import { useAppDispatch } from "../../../app/hooks";
import { moveFolder, movePrompt } from "../../../app/promptsSlice";

const getParentFolderId = (source: any, userFolders: Array<any>) => {
  if (source.parentFolderId) {
    const existingParentFolder = userFolders.find(
      (userFolder) => userFolder.id === source.parentFolderId
    );
    if (existingParentFolder) return existingParentFolder.id;
    else return 0;
  } else return 0;
};

const generateTreeData = (userPrompts: Array<any>, userFolders: Array<any>) => {
  const output = [
    ...userPrompts.map((userPrompt: any) => {
      return {
        id: userPrompt.id,
        text: userPrompt.title || "",
        parent: getParentFolderId(userPrompt, userFolders),
        droppable: false,
      };
    }),
    ...userFolders.map((userFolder: any) => {
      const output = {
        id: userFolder.id,
        text: userFolder.name,
        parent: getParentFolderId(userFolder, userFolders),
        droppable: true,
        data: { isNew: false, isEdited: false },
      };

      output.data.isNew = userFolder.isNew;
      output.data.isEdited = userFolder.isEdited;

      return output;
    }),
  ];

  return output;
};

function SideBar() {
  const dispatch = useAppDispatch();
  const userPrompts = useAppSelector(
    (state: RootState) => state.prompts.userPrompts
  );
  const userFolders = useAppSelector(
    (state: RootState) => state.prompts.userFolders
  );

  const [treeData, setTreeData] = useState<NodeModel<any>[]>(
    generateTreeData(userPrompts, userFolders)
  );

  useEffect(() => {
    setTreeData(generateTreeData(userPrompts, userFolders));
  }, [userPrompts, userFolders]);

  const handleDrop = (newTree: NodeModel<any>[], options: DropOptions<any>) => {
    if (options.dragSourceId && options.dragSource) {
      if (options.dragSource.droppable) {
        dispatch(
          moveFolder({
            sourceFolderId: options.dragSourceId,
            targetFolderId: options.dropTargetId,
          })
        );
      } else {
        dispatch(
          movePrompt({
            promptId: options.dragSourceId,
            folderId: options.dropTargetId,
          })
        );
      }
    }
    setTreeData(newTree);
  };

  return (
    <div className="tree" style={{ flexGrow: 1, textAlign: 'left' }}>
      <Tree
        tree={treeData}
        rootId={0}
        render={(node, { depth, isOpen, onToggle }) => {
          return (
            <Node
              node={node}
              depth={depth}
              isOpen={isOpen}
              onToggle={onToggle}
            />
          );
        }}
        enableAnimateExpand={true}
        dragPreviewRender={(monitorProps) => (
          <DraggedNode monitorProps={monitorProps} />
        )}
        onDrop={handleDrop}
        classes={{
          root: styles.treeRoot,
          draggingSource: styles.draggingSource,
          dropTarget: styles.dropTarget,
        }}
      />
    </div>
  );
}

export default SideBar;
